import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SelectItem } from 'primeng/primeng';
import { CONSULTA_CIGATE, MANUTENCAO_COMUNICADO } from '../../../../app.constants';
import { throttle } from '../../../shared/decorators/throttle';
import { TipoComunicadosEnum } from '../../../shared/dominios/enum/tipo-comunicados.enum';
import { TipoSituacaoEnum } from '../../../shared/dominios/enum/tipo-situacao.enum';
import { MessageUtil } from '../../../shared/messages/messageUtil';
import { ComunicacaoModel } from '../../../shared/models/comunicado.model';
import { ProcorConsultaModel } from '../../../shared/models/procor-consulta.model';
import { DateUtilService } from '../../../shared/util/date-util.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { ProcorManutencaoComunicadoService } from '../service/procor-manutencao-comunicado.service';

@Component({
  selector: 'app-procor-manutencao-comunicado-incluir-alterar',
  templateUrl: './procor-manutencao-comunicado-incluir-alterar.component.html',
  styleUrls: ['./procor-manutencao-comunicado-incluir-alterar.component.css']
})
export class ProcorManutencaoComunicadoIncluirAlterarComponent implements OnInit {

  identificadorPaginaTituloPagina: string;
  identificadorPagina = false;

  param: string;

  comunicacaoModel = new ComunicacaoModel();

  procorConsultaModel = new ProcorConsultaModel(null, null, null);


  tipoSituacaoList: SelectItem[] = TipoSituacaoEnum.values;

  dsTpComunicado: string;
  pt: any;


  constructor(
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private dateUtilService: DateUtilService,
    private procorManutencaoComunicadoService: ProcorManutencaoComunicadoService,
    private route: Router
  ) {
    this.identificarFuncaoPagina();
    this.getDadosSesseionStorage();
  }

  ngOnInit() {
    this.param = '/administrativo/procor';

    this.pt = this.dateUtilService.dataToPt();
  }


  getFormGroupClass(isValid: boolean, isPristine: boolean): {} {
    return {
      'form-group': true,
      'has-danger': !isValid && !isPristine,
      'has-success': isValid && !isPristine
    };
  }

  getFormControlClass(isValid: boolean, isPristine: boolean): {} {
    return {
      'form-control': true,
      'form-control-danger': !isValid && !isPristine,
      'form-control-success': isValid && !isPristine
    };
  }



  identificarFuncaoPagina(): void {
    this.activatedRoute.url
      .subscribe(arg => {
        (arg[1]['path'].toUpperCase() === 'alterar'.toUpperCase()) ? (this.identificadorPaginaTituloPagina = arg[1]['path'].toUpperCase(), this.identificadorPagina = true) : (this.identificadorPaginaTituloPagina = arg[1]['path'].toUpperCase())
      });
  }

  getDadosSesseionStorage(): void {
    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(MANUTENCAO_COMUNICADO);
    const novoObjeto = JSON.parse(recuperandoObjeto);

    this.procorConsultaModel = new ProcorConsultaModel(Number(novoObjeto[`tpComunicados`]), Number(novoObjeto[`sqComunicados`]), Number(novoObjeto[`anoSq`]));

    this.dsTpComunicado = TipoComunicadosEnum.getDescricaoCompleta(this.procorConsultaModel.tpComunicados);

    if (this.identificadorPagina) { this.getObtermanutcomun(this.procorConsultaModel) };

  }


  async getObtermanutcomun(procorConsultaModel: ProcorConsultaModel) {
    try {
      const comunicacaoModel = await this.procorManutencaoComunicadoService.getObtermanutcomun(procorConsultaModel.tpComunicados, procorConsultaModel.sqComunicados, procorConsultaModel.anoSq);

      (comunicacaoModel)
        ? (this.comunicacaoModel = comunicacaoModel,
          this.comunicacaoModel.dtIniVigencia = this._formataData(comunicacaoModel.dtIniVigencia),
          this.comunicacaoModel.dtTermVigencia = this._formataData(comunicacaoModel.dtTermVigencia))
        : this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 10000 });

    } catch (error) {
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 10000 });
    }
  }


  validarDatas(comunicacaoModel: ComunicacaoModel): void {
    if (comunicacaoModel.dtIniVigencia > comunicacaoModel.dtTermVigencia) {
      this.toastrService.info(`A data inicial nao pode ser maior que a data final`, 'Atenção', {
        timeOut: 10000
      })
      this.comunicacaoModel.dtIniVigencia = null;
      this.comunicacaoModel.dtTermVigencia = null;
    }
  }

  private _formataData(dtDado): Date {
    return this.dateUtilService.convertLocalDateFromServer(dtDado);
  }



  @throttle()
  onSubmit(form) {

    this.comunicacaoModel.dsTitComunicados = form.value.dsTitComunicados;
    this.comunicacaoModel.histComunicados = form.value.histComunicados;
    this.comunicacaoModel.stComunicados = form.value.stComunicados;
    this.comunicacaoModel.dsLink = form.value.dsLink;
    this.comunicacaoModel.cdCentrusReg = 629618;
    this.comunicacaoModel.anoSq = this.procorConsultaModel.anoSq;
    this.comunicacaoModel.sqComunicados = this.procorConsultaModel.sqComunicados;
    this.comunicacaoModel.tpComunicados = this.procorConsultaModel.tpComunicados;
    this.comunicacaoModel.dtIniVigencia = this.converteDataParaSalvarNoBanco(this.comunicacaoModel.dtIniVigencia);
    this.comunicacaoModel.dtTermVigencia = this.converteDataParaSalvarNoBanco(this.comunicacaoModel.dtTermVigencia);

    (this.identificadorPagina) ?
      this._update(this.comunicacaoModel)
      : this._insert(this.comunicacaoModel);
  }


  private _insert(comunicacaoModel: ComunicacaoModel): void {

    try {
      this.procorManutencaoComunicadoService.insertComunicado(comunicacaoModel);
      this.route.navigateByUrl('/administrativo/procor')
      this.toastrService.success(MessageUtil.REGISTRO_SALVO_SUCESS, 'Salvo', {
        timeOut: 10000
      });
    } catch (error) {
      this.toastrService.success(MessageUtil.ERROR_SALVAR_REGISTRO, 'Error', {
        timeOut: 10000
      });
      console.error(error);
    }
  }

  private _update(comunicacaoModel: ComunicacaoModel): void {

    delete comunicacaoModel.dtRegistro;

    try {
      this.procorManutencaoComunicadoService.updateComunicado(comunicacaoModel);
      this.route.navigateByUrl('/administrativo/procor')
      this.toastrService.success(MessageUtil.REGISTRO_ATUALIZADO_SUCESS, 'Salvo', { timeOut: 10000 });
    } catch (error) {
      this.toastrService.success(MessageUtil.ERROR_UPDATE_REGISTRO, 'Error', {
        timeOut: 10000
      });
      console.error(error);
    }
  }


  deletarComunicado(): void {
    try {
      this.procorManutencaoComunicadoService.deleteComunicado(this.comunicacaoModel);
      this.route.navigateByUrl('/administrativo/procor')
      this.toastrService.success(MessageUtil.REGISTRO_DELETED_SUCESS, 'Salvo', {
        timeOut: 10000
      });
    } catch (error) {
      this.toastrService.success(MessageUtil.ERROR_DELETE_REGISTRO, 'Error', {
        timeOut: 10000
      });
      console.error(error);
    }
  }


  converteDataParaSalvarNoBanco(data: Date): Date {
    let date;
    date = data;
    date =
      ('00' + date.getUTCDate()).slice(-2) + '-' +
      ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
      date.getUTCFullYear();
    return date;
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/procor-manutencao-comunicado/procor-manutencao-comunicado-incluir-alterar/procor-manutencao-comunicado-incluir-alterar.component.ts